// Coerce a decoded value to a finite JS number for arithmetic and formatting.
// Contract: a finite number passes through; a bigint or a numeric string becomes
// a Number; anything else, or a non-finite result, becomes 0. Unsafe 64-bit
// integers arrive from CBOR as exact decimal strings, so numeric strings are
// supported. Missing values (undefined/null) intentionally become 0; callers
// that must distinguish "absent" from "zero" check presence before coercing.
export function safeBigIntToNumber(value) {
    let n;
    if (typeof value === 'number') {
        n = value;
    } else if (typeof value === 'bigint') {
        n = Number(value);
    } else if (typeof value === 'string') {
        n = Number(value);
    } else {
        return 0;
    }
    return Number.isFinite(n) ? n : 0;
}
